import {createInstance, type i18n as I18nInstance, type Resource} from "i18next";
import {initReactI18next} from "react-i18next";
import {ru} from "./ru";

export const supportedLocales = ["ru"] as const;
export type Locale = typeof supportedLocales[number];
export type DocumentTitleKey = "meta.authTitle" | "meta.passwordResetTitle" | "meta.phoneRecoveryTitle" | "meta.spaTitle" | "meta.adminTitle" | "meta.expertTitle" | "meta.guestConsultationTitle" | "meta.favoritesTitle" | "meta.notificationsTitle" | "meta.notificationPreferencesTitle";

export const defaultLocale: Locale = "ru";
export const resources = {ru: {translation: ru}} as const;

export function createI18n(resource: Resource, language: string): I18nInstance {
  const instance = createInstance();
  let initializationError: Error | undefined;
  void instance.use(initReactI18next).init({
    resources: resource,
    lng: language,
    fallbackLng: defaultLocale,
    supportedLngs: Object.keys(resource),
    defaultNS: "translation",
    returnNull: false,
    initAsync: false,
    react: {useSuspense: false},
    interpolation: {escapeValue: false},
  }, (error) => {
    initializationError = error ?? undefined;
  });
  if (initializationError) throw initializationError;
  return instance;
}

const i18n = createI18n(resources, defaultLocale);
let documentTitleKey: DocumentTitleKey | undefined;

export function setDocumentTitle(key: DocumentTitleKey): void {
  documentTitleKey = key;
  applyDocumentLocale();
}

export async function setLocale(locale: Locale): Promise<void> {
  await i18n.changeLanguage(locale);
  applyDocumentLocale();
}

function applyDocumentLocale(): void {
  document.documentElement.lang = i18n.resolvedLanguage ?? defaultLocale;
  if (documentTitleKey) document.title = i18n.t(documentTitleKey);
}

export {ru};
export default i18n;
